module.exports = __webpack_public_path__ + "img/testimonial_1.0564d87f.png";